var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 12.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12.555 6.283l.773 1.057 1.252-.405L13.807 8l.765 1.065-1.244-.405-.773 1.058V8.405L11.303 8l1.252-.405V6.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.02 10.662a2.663 2.663 0 111.268-5.002 3.27 3.27 0 100 4.68 2.67 2.67 0 01-1.268.322z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunisia);
export default __webpack_public_path__ + "static/media/Tunisia.6b14f413d1bb4e8c0c11b6240a321bd9.svg";
export { ForwardRef as ReactComponent };